import { DisconnectKCloudApi } from "@/features/accounts/account-group/services/disconnect-kcloud-api";
import { DisconnectKCloudRequestModel } from "@/features/accounts/account-group/services/disconnect-kcloud-model";

/// サービス連携解除
export class DisconnectKCloudService {
  private disconnectKCloudApi = new DisconnectKCloudApi();

  /**
   * サービス連携解除
   */
  public async disconnectKCloud(param: DisconnectKCloudRequestModel) {
    return await this.disconnectKCloudApi.disconnectKCloud(param);
  }
}
